const carouselButtons = document.querySelectorAll('[data-button]');
carouselButtons.forEach(button => {
  button.addEventListener('click', () => {
                          const offset = button.dataset.carouselButton === 'left' ? -1 : 1;
                          const slides = button.closest('[data-carousel]').querySelector('[data-slides]');
  const activeSlide = slides.querySelector('[data-active]');

  let newIndex = [...slides.children].indexOf(activeSlide) + offset;
  if (newIndex < 0) newIndex = slides.children.length - 1;
  if (newIndex >= slides.children.length) newIndex = 0;

  delete activeSlide.dataset.active
  slides.children[newIndex].dataset.active = true;
});
});

$('.products_slider_cus').owlCarousel({
  loop: true,
  margin: 10,
  nav: true,
dots: false,
  autoplay:false,
  responsive: {
    0: {
      items: 1
    },
    600: {
      items: 2
    },
    1100: {
      items: 3
    }
  }
});
$('#testimonial_slider_cus').owlCarousel({
  loop: true,
  margin: 10,
autoplay:false,
  autoWidth:false,
  nav: true,
  dots: true,
  responsive: {
    0: {
      items: 1
    },
    600: {
      items: 1
    },
    1100: {
      items: 1
    }
  }
})
